import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../_services/index';

@Injectable()
export class ArchitectRouteGuard  {
  constructor(
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isAuthorizedUser = this.authService.isArchitect() || 
                            this.authService.isAdmin() || 
                            this.authService.isCollaborateur();
    const licence = this.authService.licence;
    const isNewAccount = this.authService.isNewAccount();
    const currentStep = this.authService.currentStep();

    if (!isAuthorizedUser) {
      return this.handleUnauthorizedAccess(state.url);
    }
    if(licence === 'pre-free-trial' && !isNewAccount && currentStep === -1 && state.url !== '/architect/demo-page') {
      this.router.navigate(['/architect/demo-page']);
      return true;
    }
    // Fully validated account
    if (!isNewAccount) {
      return true;
    }

    // Account in subscription process
    if (isNewAccount && currentStep !== -1) {
      this.router.navigate(['/architect/subscribe2'], {
        queryParams: { step: currentStep }
      });
      return false;
    }

    // Account pending validation
    if (isNewAccount && currentStep === -1) {
      this.router.navigate(['/architect/accountValidation']);
      return false;
    }
    // if(!this.authService.isAdminArchitect){
    //   this.router.navigate(['/architect/my-consultations']);
    //   return false;
    // }
    
    return false;
  }

  private handleUnauthorizedAccess(returnUrl: string): boolean {
    this.router.navigate(['/login'], { 
      queryParams: { 
        returnUrl: returnUrl, 
        infoBubble: "login-required" 
      }
    });
    return false;
  }
}